import type { SumExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const sumResolver = createSimpleNamedExpressionResolver<SumExpression>(
  'sum',
  values => values.reduce((p, c) => p + Number(c), 0)
);
